import './App.css';
import React, { useState, useEffect } from 'react';
import RevSend from './components/buttonSend/RevSend';
import Modal from './components/modal/modalEnd';
import Stars from './components/stars/stars';
import MainText from './components/MainText/MainText';
import { useDispatch, useSelector } from 'react-redux';
import headerImg from './components/modal/headerImage.svg';
import { UrlReview } from './api/urlReview';
import { DepartmentApi } from './api/departmentApi';
import { SettingApi } from './api/settingApi';

function App() {

  const qrFeed = 'qr-feedback';
  const dispatch = useDispatch()
  const sendRev = useSelector(state => state.sendRev);
  const [postResponse, setPostResponse] = useState("");
  const [postResponseSourceName, setPostResponseSourceName] = useState("");
  const [depNum, setDepNum] = useState(0);
  const [depName, setDepName] = useState("");
  const [isCastomPage, setCastomPage] = useState(false);
  const [baseText, setBaseText] = useState(null);

  useEffect(() => {
    try {
      const path = window.location.pathname.split('/');

      if (!window.location.pathname.includes(qrFeed)) {
        setDepNum(path[1]);

        const addCash = () => {
          dispatch({ type: "ADD_DEPNUMBER", payload: depNum })
        }
        addCash();

        let body = {
          "depId": path[1]
        }

        var dataUrl = UrlReview.getUrl(body).then(response => response);

        dataUrl.then(res => {
          setPostResponse(res.urlMap);
          setPostResponseSourceName(res.nameServiceMap)
        });

        var departmentApi = DepartmentApi.getDepartmenetInfo(path[1], path[path.length - 1]).then(response => response);
        departmentApi.then(res => {
          setDepName(res.depName);
        })
      }
      else {
        setCastomPage(true);

        let settingApi = SettingApi
          .settings(path[1])
          .then(response => response)
          .catch(error => console.log('Ошибка запроса:', error));

        settingApi.then(res => {
          if (res !== undefined) {
            if (res.departmentNumber !== undefined && res.departmentNumber !== null) {
              setDepNum(res.departmentNumber);
            }
            if (res.departmentName !== undefined && res.departmentName !== null) {
              setDepName(res.departmentName);
            }
            if (res.mainText !== undefined && res.mainText !== null) {
              setBaseText(res.mainText);
            }
            if (res.reviewLink !== undefined && res.reviewLink !== null) {
              setPostResponse(res.reviewLink);
            }
          }
        });
      }
    }
    catch (error) {
      console.error('Ошибка запроса:', error);
      return null;
    }
  }, [])

  let res = "";

  if (sendRev === false) {
    res = <div className='App'>
      <div className='header' >
        <div className='headerSvgStyle'>
          <img alt="" src={headerImg}></img>
        </div>
        <h1 className='post'>Оставьте отзыв</h1>
      </div>
      <div className='textBox'>
        <MainText depName={depName} text={baseText}></MainText>
        <Stars urlMap={postResponse} sorceUrlMap={postResponseSourceName}></Stars>
        <RevSend isQrFeedBack={isCastomPage}></RevSend>
      </div>
    </div>
  }
  else {
    res = <div className='App'>
      <div className='textBox'>
        <Modal></Modal>
      </div>
    </div>
  }

  return (
    res
  );
}

export default App;
